interface ErrorBoundaryDataInterface {
  mediaLibrarySection: {
    headingText: string;
    buttonText: string;
  };
  contentSection: {
    headingText: string;
    buttonText: string;
  };
  previewMediasSection: {
    headingText: string;
    buttonText: string;
  };
}

const errorBoundaryData: ErrorBoundaryDataInterface = {
  mediaLibrarySection: {
    headingText: 'media_library_not_load',
    buttonText: 'media_library_try_again',
  },
  contentSection: {
    headingText: 'content_section_not_load',
    buttonText: 'content_section_try_again',
  },
  previewMediasSection: {
    headingText: 'preview_section_not_load',
    buttonText: 'preview_medias_try_again',
  },
};

export default errorBoundaryData;
